export function ProjectSection({ title, className = "", children }) {
  return <section className={`project-detail-section project-section-shell ${className}`.trim()}><h3>{title}</h3>{children}</section>;
}

export function UnsavedProjectSection({ title }) {
  return <ProjectSection title={title} className="project-section-disabled"><p className="empty-hint">Diese Funktion wird nach dem Speichern des Projekts verfügbar.</p></ProjectSection>;
}
